<template>

    <form ref="candidato-form-create" v-on:submit.prevent="executeCreate(model, false)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="cargoId">Cargo</label>
                <select v-select="{ dataitem: 'Cargo', default: 'Selecione', filters: { attributeBehavior: 'CargoHierarquiaEspecificos', podeAplicarTeste: true } }"
                        v-model="model.cargoId"
                        @change="verificacoesNovaCandidatura()"
                        class="form-control"
                        name="cargoId"
                        required></select>
            </div>

            <div class="col-md-12" v-if="ultimoTesteRealizadoAprovado">
                <div class="alert alert-primary">
                    Existe um teste já aprovado para o candidato de outro processo realizado, você poderá reaproveitar este teste.
                </div>
            </div>

            <div class="col-md-12 mb-3" v-if="ultimoTesteRealizadoAprovado">
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Feito em</th>
                                <th>Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="animated fadeIn">
                                <td>{{ ultimoTesteRealizadoAprovado.escola.nomeEscola }}</td>
                                <td>{{ ultimoTesteRealizadoAprovado.teste.dtTermino }}</td>
                                <td>{{ ultimoTesteRealizadoAprovado.teste.situacaoTeste.nome }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-md-12" v-if="liberarContracaoDireta">
                <div class="alert alert-warning">
                    Constatamos que este candidato já faz parte da sua rede de escolas, caso deseje poderá contratar diretamente sem passar pelo processo de teste e entrevista.
                </div>
            </div>

            <div class="col-md-12" v-if="temCargoEscolaLogado">
                <div class="alert alert-info">
                    O candidato já tem este cargo na sua escola.
                </div>
            </div>

            <div class="col-md-12" v-if="indisponivel">
                <div class="alert alert-info">
                    {{indisponivelObservacao}}
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" v-b-tooltip title="O candidato terá que realizar um novo teste e entrevista." @click="executeCreate(model, false, false)" :disabled="indisponivel">
            <span>Nova Candidatura</span>
        </button>
        <button type="button" class="btn btn-primary float-right" v-b-tooltip title="O candidato utilizará o último teste aprovado e irá direto para a entrevista." @click="executeCreate(model, true, false)" v-if="ultimoTesteRealizadoAprovado">
            <span>Reaproveitar teste</span>
        </button>
        <button type="button" class="btn btn-warning float-right" v-b-tooltip title="O candidato não precisará realizar teste e entrevista, será contratado imediatamente." @click="executeCreate(model, false, true)" v-if="liberarContracaoDireta">
            <span>Contratar diretamente</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "candidato-form-create",
        mixins: [base],
        props: { colaboradorId: Number, escolaId: Number },
        data: () => ({

            model: {},

            form: "candidato-form-create",

            ultimoTesteRealizadoAprovado: null,
            liberarContracaoDireta: false,
            temCargoEscolaLogado: false,
            indisponivelObservacao: "",
            indisponivel: false,
        }),

        methods: {

            executeCreate: function (model, reaproveitar, contratar) {

                if (this.formValidate() == false)
                    return;

                model.testeId = null;
                model.colaboradorId = this.colaboradorId;
                model.escolaId = this.escolaId;

                if (reaproveitar)
                    model.testeId = this.ultimoTesteRealizadoAprovado.testeId;

                this.showLoading();

                new Api('candidato').post(model).then(data => {
                    let _data = data.data;
                    _data.reaproveitado = reaproveitar;
                    _data.contratado = contratar;
                    if (contratar) {
                        new Api('candidato').post({
                            candidatoId: _data.candidatoId,
                            attributeBehavior: "ContratarColaborador"
                        }).then(() => {
                            this.$emit('on-saved', _data)
                            this.defaultSuccessResult('Candidato contratado.');
                        });
                    }
                    else {
                        this.$emit('on-saved', _data)
                        this.defaultSuccessResult('Registro inserido com sucesso.');
                    }

                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            verificacoesNovaCandidatura: function () {                
                this.verificaTesteIndisponivel();

                if (this.indisponivelObservacao == "") {
                    this.verificaOutrasCandidaturas();
                    this.verificaCandidatoEscolasRede();
                    this.verificaCandidatoCargoEscolaLogada();
                }
                else {
                    return this.indisponivelObservacao;
                }
            },

            verificaTesteIndisponivel: function () {  
                new Api('avaliacao/obterAviso').get({                    
                    cargoId: this.model.cargoId,                    
                }).then(data => {
                    if (data != "") {
                        this.indisponivelObservacao = data;
                        this.indisponivel = true;
                    }
                    else {
                        this.indisponivelObservacao = "";
                        this.indisponivel = false;
                    }
                });
            },

            verificaOutrasCandidaturas: function () {
                this.ultimoTesteAprovado = 0;
                new Api('candidato/getultimacandidatura').get({
                    colaboradorId: this.colaboradorId,
                    cargoId: this.model.cargoId,
                }).then(data => {
                    this.ultimoTesteRealizadoAprovado = data.data;
                });
            },

            verificaCandidatoEscolasRede: function () {
                this.liberarContracaoDireta = false;
                new Api('candidato/verificacandidatoescolasrede').get({
                    colaboradorId: this.colaboradorId,
                    cargoId: this.model.cargoId,
                }).then(data => {
                    this.liberarContracaoDireta = data.data;
                });
            },

            verificaCandidatoCargoEscolaLogada: function () {
                this.temCargoEscolaLogado = false;
                new Api('candidato/verificacandidatocargoescolalogada').get({
                    colaboradorId: this.colaboradorId,
                    cargoId: this.model.cargoId,
                }).then(data => {
                    this.temCargoEscolaLogado = data.data;
                });
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

